import React, { useState, useEffect, useRef, useContext, useMemo, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';
import SideMenu from '../../../GlobalComponents/Sidebar/AdminMenu';
//import global components
import { Modal, SideBar, Table } from '../../../../imports';
import { ObtenerPorVacanteUsuario } from '../../../../servicios/ServicioProcesos';

//import services
import { ObtenerVacantes, ObtenerVacantesCompleto, EditarVacantes, EditarInactivoVacantes, AgregarVacantes } from '../../../../servicios/ServicioVacante.js';

//import icons from heroicons
import { PlusCircleIcon, ExclamationTriangleIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useLoader } from '../../../../context/LoaderContext.';


export default function Vacantes({ validationMessages }) {


    //list to save and send data to table
    const [listVacantes, setListVacantes] = useState([]);
    const [listPostulantes, setListPostulantes] = useState([]);

    //use alert context
    const alertCtx = useContext(AlertContext);

    //use modal and show for add
    const [showAddModal, setShowAddModal] = useState(false);

    //use modal and show for edit
    const [showEditModal, setShowEditModal] = useState(false);

    const [showPostulantesModal, setShowPostulantesModal] = useState(false);

    //use modal and show for delete
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    //use to get id with set options when click events
    const [idFromEdit, setIdFromEdit] = useState(null);
    const [idFromDeactivate, setIdFromDeactivate] = useState(0);
    const { showLoader, hideLoader } = useLoader();

    //use to get state from colums
    const [stateTech, setStateTech] = useState(null);

    //get current user id
    const jsonUsuario = sessionStorage.getItem("USER_DATA");
    const usuario = JSON.parse(jsonUsuario);



    //declare register to form
    //use react hook form to get values and make validations
    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({
        mode: 'all',
        defaultValues: {
            techName: ''
        }
    });



    async function getTechnologies() {

        showLoader();
        const response = await ObtenerVacantesCompleto();
        hideLoader();
        setListVacantes(response);

    }

    async function EditTech(id, vacante) {

        const data = {
            IdVacante: id,
            Descripcion: vacante.descripcion,
            FechaCierre: vacante.fechaCierre,
            CantidadPuestos: vacante.cantidadPuestos,
            UsuarioCreacion: String(usuario.Correo)
        }

        showLoader();
        const response = await EditarVacantes(data);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    async function AddTechnologie(vacante) {

        const data = {
            Descripcion: vacante.descripcion,
            FechaCierre: vacante.fechaCierre,
            CantidadPuestos: vacante.cantidadPuestos,
            UsuarioCreacion: String(usuario.Correo),
            Estado: true
        }

        showLoader();
        const response = await AgregarVacantes(data);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    async function DeactivateTech(id, estado) {

        const data = {
            IdVacante: id,
            UsuarioCreacion: String(usuario.Correo),
            Estado: estado
        }


        showLoader();
        const response = await EditarInactivoVacantes(data);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    const consultarPostulantesVacante = async (vacante) => {
        setValue("techName", vacante.descripcion)
        const data = {
            vacante: vacante.idVacante,
            usuario: 0
        }
        showLoader();
        const response = await ObtenerPorVacanteUsuario(data);
        hideLoader();

        setListPostulantes(response);
        setShowPostulantesModal(true);

    }

    const columnsPostulantes = [

        {
            name: 'Identificacion',
            selector: row => row?.identificacion,
        },
        {
            name: 'Nombre',
            selector: row => row?.nombres,
        },
        {
            name: 'Prioridad',
            selector: row => row?.prioridad,
        },
        {
            name: 'Descripción',
            selector: row => row?.descripcion,
        },
        {
            name: "Estado",
            cell: row => {
                let icon = null;
                let color = null;
                switch (row.estado) {
                    case "Contratado":
                        icon = "✔️";
                        color = "green";
                        break;
                    case "Descartado":
                        icon = "❌";
                        color = "red";
                        break;
                    case "En Proceso":
                        icon = "⌛";
                        color = "blue";
                        break;
                }
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>{row.estado}</span>
                        <span style={{ color, fontSize: "20px" }}>{icon}</span>
                    </div>
                );
            },
            sortable: true,
        },

    ]

    const accionEditarVacante = (row) => {
        setShowEditModal(true);
        setIdFromEdit(row?.idVacante);
        setValue("techNameE", row?.descripcion);
        setValue("fechaCierreE", row?.fechaCierre.split("T")[0]);
        setValue("cantidadPuestosE", row?.cantidadPuestos);
    }

    const cambiarEstadoVacante = (row) => {
        const fechaCierre = new Date(row.fechaCierre)
        const hoy = new Date();
        if (hoy < fechaCierre && row.estado === false) { 
            setStateTech(row?.estado);
            setIdFromDeactivate(row?.idVacante);
            setShowDeleteModal(true);
        } else {
            alertCtx.error("No es posible editar la vacante ya que la fecha de cierre se ha cumplido.");
        }
    }

    //**change this colums with entities names or need data**op
    const columns = [
        {
            name: 'Descripcion',
            selector: row => row?.descripcion,

        },
        {
            name: 'Fecha Cierre',
            selector: row => new Date(row?.fechaCierre).toLocaleDateString(),
        },
        {
            name: 'Cantidad Puestos',
            selector: row => row?.cantidadPuestos,
        },
        {
            name: 'Estado',
            selector: row => row?.estado ? "Abierta" : "Cerrada",
        },
        {
            name: 'Acciones',
            selector: row => row?.estado,
            cell: (row) =>
                <div>
                    <button type="button" id={row?.IdVacante} onClick={() => { accionEditarVacante(row); }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-black-RS text-black-RS font-bold  m-2 hover:border-gray-200 ">Editar</button>
                    {row?.estado === true ? <button type="button" id={row?.idVacante} onClick={() => { setStateTech(row?.estado); setIdFromDeactivate(row?.idVacante); setShowDeleteModal(true); }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-red-RS text-red-RS font-bold  m-2 hover:border-gray-200  " >Cerrar</button >
                        : <button type="button" id={row?.idVacante} onClick={() => { cambiarEstadoVacante (row)}} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-greenButton text-greenButton font-bold  m-2 hover:border-gray-200" >Activar</button >}

                    <button type="button" id={row?.IdVacante} onClick={() => { consultarPostulantesVacante(row) }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-black-RS text-black-RS font-bold  m-2 hover:border-gray-200 ">Postulantes</button>
                </div>
            ,
            width: "500px",
            ignoreRowClick: true,
            allowOverflow: true,
        },

    ]

    const onSaveEditOptions = () => {
        const techName = getValues("techNameE");
        const fecha = getValues("fechaCierreE");
        const cantidadVac = getValues("cantidadPuestosE");

        const obj = { descripcion: techName, fechaCierre: fecha, cantidadPuestos: cantidadVac }

        EditTech(idFromEdit, obj)

        setShowEditModal(false);

        setValue("techNameE", "");
        setValue("fechaCierreE", "");
        setValue("cantidadPuestosE", "");
        setShowEditModal(false);

        const timeout = setTimeout(() => {
            getTechnologies();
        }, 1000);
        return () => clearTimeout(timeout);
    }

    const onSaveDeleteOptions = () => {

        DeactivateTech(idFromDeactivate, !stateTech)

        setShowDeleteModal(false);
        const timeout = setTimeout(() => {
            getTechnologies();
        }, 1000);
        return () => clearTimeout(timeout);
    }

    const onSaveAddOptions = () => {
        const techName = getValues("techName");
        const fecha = getValues("fechaCierre");
        const cantidadVac = getValues("cantidadPuestos");

        const obj = { descripcion: techName, fechaCierre: fecha, cantidadPuestos: cantidadVac }

        AddTechnologie(obj);

        setShowAddModal(false);

        const timeout = setTimeout(() => {
            setValue("techName", "");
            setValue("fechaCierre", "");
            setValue("cantidadPuestos", "");
            getTechnologies();

        }, 1000);
        return () => clearTimeout(timeout);
    }

    //when component start, get list
    useState(() => {
        getTechnologies();

    }, [])

    useEffect(() => {

    }, [showAddModal, showDeleteModal, showEditModal, stateTech])

    //use to show add new role component when 'agregar' button is activated
    const AddTechComponent = () => {
        return (
            <>
                <form className="space-y-2 md:space-y-4">
                    <div className="w-96 container mx-auto items-center justify-center">
                        <div className="flex flex-col">
                            <div className="flex text-base m-2 justify-center mx-auto font-bold leading-tight tracking-tight text-green-500">
                                <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                            </div>
                            <div>
                                <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                                    Agregar Catalogo Vacantes
                                </h1>
                            </div>


                            {/*First row*/}
                            <div className="flex flex-wrap mx-2 mx-auto items-center justify-center">
                                {/**/}
                                <div className="w-full m-3 px-2  md:w-80">
                                    <label className="block mb-2 text-sm font-medium text-white">Descripcion</label>
                                    <div className="relative flex items-center">
                                        <input
                                            type="text"
                                            name="techName"
                                            {...register("techName", { required: "El nombre es requerida", maxLength: 25 })}
                                            id="techName"
                                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                            placeholder="Descripcion"
                                        />
                                    </div>
                                    {errors?.techName && (
                                        <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.techName.message}</span>
                                    )}
                                    <label className="block mb-2 text-sm font-medium text-white">Fecha de cierre</label>
                                    <div className="relative flex items-center">
                                        <input
                                            type="date"
                                            name="fechaCierre"
                                            {...register("fechaCierre", { required: "La fecha de cierre es requerida", maxLength: 25 })}
                                            id="fechaCierre"
                                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                            placeholder="Fecha de cierre"
                                        />
                                    </div>
                                    {errors?.fechaCierre && (
                                        <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.fechaCierre.message}</span>
                                    )}
                                    <label className="block mb-2 text-sm font-medium text-white">Cantidad de puestos</label>
                                    <div className="relative flex items-center">
                                        <input
                                            type="number"
                                            name="cantidadPuestos"
                                            {...register("cantidadPuestos", {
                                                required: "La cantidad de puestos es requerida",
                                                valueAsNumber: true, // Convierte el valor a número
                                                validate: (value) => value >= 0 || "Debe ser un número positivo", // Validación adicional
                                                maxLength: {
                                                    value: 25,
                                                    message: "El valor no debe superar 25 caracteres",
                                                },
                                            })}
                                            id="cantidadPuestos"
                                            className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                            placeholder="Cantidad de puestos"
                                        />
                                    </div>
                                    {errors?.cantidadPuestos && (
                                        <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.cantidadPuestos.message}</span>
                                    )}
                                </div>

                            </div>

                        </div>
                    </div>
                </form>
            </>
        )
    }

    //use to show edit role component when 'editar' button is activated
    const EditTechComponent = () => {
        return (
            <form className="space-y-2 md:space-y-4">
                <div className="w-96 container mx-auto items-center justify-center">
                    <div className="flex flex-col">
                        <div className="flex text-base m-2 justify-center mx-auto font-bold leading-tight tracking-tight text-green-500">
                            <PencilIcon className="w-8 h-8 ml-2"></PencilIcon>
                        </div>
                        <div>
                            <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                                Editar Catalogo Vacantes
                            </h1>
                        </div>

                        {/*First row*/}
                        <div className="flex flex-wrap mx-2 mx-auto items-center justify-center">
                            {/**/}
                            <div className="w-full m-3 px-2  md:w-80">
                                <label className="block mb-2 text-sm font-medium text-white">Descripcion</label>
                                <div className="relative flex items-center">
                                    <input
                                        type="text"
                                        name="techName"
                                        {...register("techNameE", { required: "La descripcion es requerida", maxLength: 25 })}
                                        id="techName"
                                        className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                        placeholder="Descripcion"
                                    />
                                </div>
                                {errors?.techNameE && (
                                    <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.techNameE.message}</span>
                                )}
                                <label className="block mb-2 text-sm font-medium text-white">Fecha de cierre</label>
                                <div className="relative flex items-center">
                                    <input
                                        type="date"
                                        name="fechaCierre"
                                        {...register("fechaCierreE", { required: "La fecha de cierre es requerida", maxLength: 25 })}
                                        id="fechaCierre"
                                        className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                        placeholder="Fecha de cierre"
                                    />
                                </div>
                                {errors?.fechaCierreE && (
                                    <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.fechaCierreE.message}</span>
                                )}
                                <label className="block mb-2 text-sm font-medium text-white">Cantidad de puestos</label>
                                <div className="relative flex items-center">
                                    <input
                                        type="number"
                                        name="cantidadPuestos"
                                        {...register("cantidadPuestosE", {
                                            required: "La cantidad de puestos es requerida",
                                            valueAsNumber: true, // Convierte el valor a número
                                            validate: (value) => value >= 0 || "Debe ser un número positivo", // Validación adicional
                                            maxLength: {
                                                value: 25,
                                                message: "El valor no debe superar 25 caracteres",
                                            },
                                        })}
                                        id="cantidadPuestos"
                                        className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                                        placeholder="Cantidad de puestos"
                                    />
                                </div>
                                {errors?.cantidadPuestosE && (
                                    <span style={{ color: 'red', marginTop: 1, fontSize: 13 }}>{errors?.cantidadPuestosE.message}</span>
                                )}
                            </div>

                        </div>



                    </div>
                </div>
            </form>
        )
    }

    const ListaPostulantesComponent = () => {
        return (
            <form className="space-y-2 md:space-y-4">
                <div className="w-96 container mx-auto items-center justify-center">
                    <div className="flex flex-col">
                        <div>
                            <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                                Postulantes de vacante {getValues("techName")}
                            </h1>
                        </div>
                    </div>
                </div>
                {/**/}

                <div className="static px-2 mt-2 m-2">
                    <Table columns={columnsPostulantes} title="Postulantes" filteredItems={""} data={listPostulantes} filterBy="nombres" />
                </div>
            </form>
        )
    }

    //use to show delete new role component when 'eliminar' button is activated
    const DeleteTechComponent = () => {
        return (
            <form className="space-y-2 md:space-y-4">
                <div className="w-96 container mx-auto items-center justify-center">
                    <div className="flex flex-col">
                        <div className="flex text-base m-2 justify-center mx-auto font-bold leading-tight tracking-tight text-red-RS">
                            <ExclamationTriangleIcon className="w-8 h-8 ml-2"></ExclamationTriangleIcon>
                        </div>
                        <div>
                            <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                                Advertencia
                            </h1>
                        </div>

                        <div>
                            <label className="flex text-base justify-center mx-auto m-2 py-2 text-sm font-medium text-white">¿Está seguro que desea cambiar el estado de este elemento?</label>
                        </div>

                    </div>
                </div>
            </form>
        )
    }
    return (
        <>

            <div className="flex flex-row">
                <div className="md:basis-1/4 xl:basis-1/5 ">
                    <SideBar />
                </div>
                <div className="md:basis-3/4 xl:basis-11/12">
                    <div className="bg-white rounded-lg shadow-lg shadow-slate-400 px-2 py-2  mt-2 m-2 mr-8">

                        <div className="px-2">
                            <div className="absolute z-20 ml-4 mt-1">
                                <h1 className="left-0 text-xl font-bold text-black-RS mb-1">Catalogo Vacantes</h1>
                                <div className="col-start-1 col-end-3 ">
                                    <div className="items-center sm:flex">
                                        <button type="button" onClick={() => { setShowAddModal(!showAddModal); setValue("techName", ""); setValue("fechaCierre", ""), setValue("cantidadPuestos", "") }} className="bg-greenButton hover:bg-primary-700 text-white text-sm  py-2 px-4 rounded inline-flex items-center">
                                            <span>Agregar</span>
                                            <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="static px-2 mt-2 m-2">
                                <Table columns={columns} title="vacantes" filteredItems={""} data={listVacantes} filterBy="descripcion" />
                            </div>
                        </div>
                        {/*Here we show add modal compononent*/}
                        <Modal isVisible={showAddModal} onClose={() => { setShowAddModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveAddOptions} showCloseIcon={false} >
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowAddModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <AddTechComponent />
                        </Modal>

                        {/*Here we show edit modal compononent*/}
                        <Modal isVisible={showEditModal} onClose={() => { setShowEditModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveEditOptions} showCloseIcon={false} >
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowEditModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <EditTechComponent />
                        </Modal>

                        <Modal isVisible={showPostulantesModal} showFotter={false} onClose={() => { setShowPostulantesModal(false) }} showCloseIcon={false} >
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowPostulantesModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <ListaPostulantesComponent />
                        </Modal>

                        {/*Here we show delete modal compononent*/}
                        <Modal isVisible={showDeleteModal} onClose={() => { setShowDeleteModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveDeleteOptions} showCloseIcon={false}>
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowDeleteModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <DeleteTechComponent />
                        </Modal>

                    </div>
                </div>

            </div>

        </>
    )
}
